import { RestAPI } from "@aws-amplify/api-rest";
import { toast } from "react-toastify";

import { applyFormulas } from "./area";

const AREA_FORMAT_KEY = "number.dec.4";

const TREE_TABLE = 1;
const DATA_TABLE = 2;

const addDataAWS = (data, setDialogState, url, t, updatingRef, addRecord) => {

    RestAPI.post("apiAdminDropControl", url, { body: data }).then((r) => {
        if (!r || !r.permiso_id) throw new Error("Nothing received");
        addRecord(r);
        setDialogState({ visible: false });
        updatingRef.current = false;
        toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
    }).catch((e) => {
        console.error(e);
        setDialogState((e) => ({ ...e, disabled: false }));
        updatingRef.current = false;
        toast.info(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
    });
};

const deleteDataAWS = (data, key, keyValue, url, t, dispatch, updatingRef) => {

    RestAPI.post("apiAdminDropControl", url, { body: data }).then((r) => {
        if (!r || !r.del) throw new Error("Nothing received");
        updatingRef.current = {type:"delete", data:{key,keyValue},r};
        dispatch(null); // force re-render
        toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
    }).catch((e) => {
        console.error(e);
        toast.info(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
        parent.hideSpinner();
    });
};

const modifyDataAWS = (data, oldData, setDialogState, keyValue, url, t, updatingRef, alwaysAdd, source) => {
    let oldValue = null, newValue = null, isModified = false;
    const newValues = {};
    if (data[alwaysAdd] !== undefined) {
        newValues[alwaysAdd] = data[alwaysAdd];
    }

    const keys = Object.keys(data);
    keys.forEach((k) => {
        if (k === alwaysAdd) return;
        oldValue = Object.getOwnPropertyDescriptor(oldData, k);
        newValue = Object.getOwnPropertyDescriptor(data, k);
        if ((newValue && newValue.value !== undefined) && (!oldValue || (oldValue.value !== newValue.value))) {
            // needed because of https://github.com/formium/formik/issues/1869
            newValues[k] = newValue.value === "" ? null : newValue.value;
            isModified = true;
        }
    });
    if (!isModified) {
        setDialogState({ visible: false });
        updatingRef.current = false;
        toast.info(t("forms.toastInfo"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
        return;
    }
    RestAPI.post("apiAdminDropControl", url, { body: newValues }).then((r) => {
        if (!r || !r.permiso_id) throw new Error("Nothing received");
        setDialogState({ visible: false });
        updatingRef.current = {type:"update", data:r};
        toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
    }).catch((e) => {
        console.error(e);
        setDialogState((e) => ({ ...e, disabled: false }));
        updatingRef.current = false;
        toast.info(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
    });
};

const findNodeAndChildren = (data, selectedNodeKey) => {
    for (const node of data) {
        if (node.key === selectedNodeKey) {
            return node;
        }
        if (node.children) {
            const foundInChildren = findNodeAndChildren(node.children, selectedNodeKey);
            if (foundInChildren) {
                return foundInChildren;
            }
        }
    }
    return null;
};

function findKey(nodes,key, newValues) {
    for (let i = 0; i < nodes.length; i++) {
        const nodo = nodes[i];
        if (nodo[key] === newValues[key]) {
            return nodo.key;
        }
        if (nodo.children && nodo.children.length > 0) {
            const children = findKey(nodo.children, key, newValues);
            if(children) return children;
        }
    }
}

function isInDateRange(date1, date2, days) {
    const time1 = date1.getTime();
    const time2 = date2.getTime();
    const diffMili = Math.abs(time1 - time2);
    const difDays = Math.ceil(diffMili / (1000 * 60 * 60 * 24));
    return difDays >= days;
}
const createDateTimeFromString = (timeString) => {
    if(timeString){
        const now = new Date();
        const [hours, minutes] = (timeString ?? "").split(":").map(Number);
        if(hours) now.setHours(hours);
        if(minutes) now.setMinutes(minutes);
        now.setSeconds(0);
        return now;
    }
};
const getTimeFromDate = (date) => {
    if(date){
        const hours = date?.getHours();
        let minutes = date?.getMinutes();
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        return hours + ":" + minutes;
    }
};
const hourSet = ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"];
const escapeXML = (text) => {
    return text.replace(/[<>&'"/$#^`{}[\]-_.:,ñ¡?¿=]/g, (c) => {
        switch (c) {
            case "<": return "&lt;";
            case ">": return "&gt;";
            case "&": return "&amp;";
            case "'": return "&apos;";
            case "\"": return "&quot;";
            case "/": return "&#x2F;";
            case "$": return "&#x24;";
            case "#": return "&#x23;";
            case "^": return "&#x5E;";
            case "`": return "&#x60;";
            case "{": return "&#x7B;";
            case "}": return "&#x7D;";
            case "[": return "&#x5B;";
            case "]": return "&#x5D;";
            case "-": return "&#x2D;";
            case "_": return "&#x5F;";
            case ".": return "&#x2E;";
            case ":": return "&#x3A;";
            case ",": return "&#x2C;";
            case "ñ": return "&#xF1;";
            case "¡": return "&#xA1;";
            case "?": return "&#x3F;";
            case "¿": return "&#xBF;";
            case "=": return "&#x3D;";
            default: return c;
        }
    });
};
const primeUpdate = async (key, formData, previousData, awsOptions, primeValues,setPrimeValues, type, setDialogState, setLoadingDialog, dialogState, selectedNodesKeys, selectedNodesData) => {
    let disabled = false;

    setDialogState({ visible: false });
    setLoadingDialog(true);
    try {
        if (dialogState.target) {
            const { areaInfo, hidraInfo, canModify, promiseWrapper, extraData, url, t, closeEstadosRef } = awsOptions?.current || {};
            const id = formData && formData[key];
            if (!id) throw Error("No valid data object");
            const mapRes = formData.mapRes;
            delete formData.mapRes;
            let oldValue, newValue, isModified = false;
            const values = canModify && canModify.reduce((result, field) => {
                oldValue = Object.getOwnPropertyDescriptor(previousData, field);
                newValue = Object.getOwnPropertyDescriptor(formData, field);

                if (newValue && newValue.value !== undefined &&
          (!oldValue || (oldValue.value !== newValue.value))) {
                    result[field] = newValue.value === "" ? null : newValue.value;
                    isModified = true;
                }
                return result;
            }, {});
            if (canModify && canModify.includes("grupo_variador_id")) {
                if (formData.grupo_variador_id) {
                    values.grupo_variador_id = formData.grupo_variador_id;
                }
                if (hidraInfo) {
                    values.variador_frecuencia_id = hidraInfo.variador_frecuencia_id;
                    values.hidraulica_id = hidraInfo.hidraulica_id;
                }
            }
            if (formData.tipo && values) {
                values.tipo = formData.tipo;
                // we can edit area for irrigation sectory only if has one block
                if (values.superficie !== undefined && values.tipo.includes(3) && !previousData.one_block) delete values.superficie;
            }

            if (!isModified) {
                const resolved = mapRes && (await mapRes);
                if (resolved !== undefined) {
                    if (resolved) {
                        toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                    } else toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                } else {
                    toast.info(t("forms.toastInfo"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                }
                setLoadingDialog(false);
                return {};
            }

            try {
                const { formula_to_kilo_base, formula_from_kilo_base, formula_to_base, formula_from_base } = areaInfo || {};
                // convert from kilo_unidad to unidad
                if (values.superficie && formula_to_kilo_base && formula_from_base) {
                    // we can use formula2( formula1( sup * 10.000 ) )
                    // instead of formula2( formula1( sup ) * 10.000 ) for area
                    values.superficie = applyFormulas(values.superficie * 10000, formula_to_kilo_base, formula_from_base);
                }

                if (((values.superficie !== undefined) || (values.caudal_teorico !== undefined)) && promiseWrapper && promiseWrapper.current) {
                    setLoadingDialog(false);
                    values.recalc = await promiseWrapper.current.getPromiseAnswer();
                    setLoadingDialog(true);
                }
                if (extraData) Object.assign(values, extraData);

                if (values.plantilla_estado_fenologico_id !== undefined && previousData.plantilla_estado_fenologico_id){
                    setLoadingDialog(false);
                    const closeEstados = await closeEstadosRef.current.getPromiseAnswer();
                    setLoadingDialog(true);
                    if (!closeEstados) {
                        setLoadingDialog(false);
                        return { key, crudUpdate: { ...previousData, taskData: undefined } };
                    }
                }
                const crudData = await RestAPI.post("apiAdminDropControl", `${url}/${id}`, { body: values });
                if (!crudData) throw new Error("No values were modified");

                // convert from unidad to kilo_unidad
                if (crudData.superficie !== undefined) crudData.apiArea = crudData.superficie;
                if (crudData.superficie && formula_from_kilo_base && formula_to_base) {
                    // we can use formula2( formula1( sup / 10.000 ) )
                    // instead of formula2( formula1( sup ) / 10.000 ) for area
                    crudData.superficie = applyFormulas(crudData.superficie / 10000, formula_to_base, formula_from_kilo_base, AREA_FORMAT_KEY);
                }

                const resolved = mapRes && (await mapRes);
                if (resolved !== undefined && !resolved) {
                    toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                }
                else {
                    toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });

                    if (crudData.ticketResult){
                        let ticketMessage;
                        if (crudData.ticketResult.ticketCreated || crudData.ticketResult.emailSent) ticketMessage = t("forms.ticketCreated");
                        if (crudData.ticketResult.ticketUpdated) ticketMessage = t("forms.ticketUpdated");
                        if (crudData.ticketResult.ticketId) ticketMessage += ` ${t("forms.ticketId", { id: crudData.ticketResult.ticketId })}`;
                        if (ticketMessage) toast.info(ticketMessage, { position: toast.POSITION.TOP_RIGHT, autoClose: false });
                    }
                }
                if(type===TREE_TABLE){
                    const nodeKey = findKey(primeValues, key, formData);
                    const indexes = nodeKey.split("-").map(Number);
                    let node = primeValues;
                    for (let i = 0; i < indexes.length; i++) {
                        const index = indexes[i];
                        if (node[index] && node[index].children) {
                            node = node[index].children;
                        } else if (i === indexes.length - 1) {
                            node[index] = {...node[index], ...formData};
                            node[index].data = {...node[index], ...formData};
                        } else {
                            return false;
                        }
                    }
                }
                if(type===DATA_TABLE){
                    const nodes = primeValues;
                    const index = nodes.findIndex(n => n[key] === formData[key]);
                    if(index >=0){
                        nodes[index] = {...nodes[index], ...formData};
                    }
                }
                setPrimeValues(primeValues);
                setLoadingDialog(false);
            } catch (err) {
                toast.info(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                setLoadingDialog(false);
                throw err;
            }
        }
        else if (Array.isArray(dialogState.allowList)) {
            disabled = true;
            setDialogState((e) => ({ ...e, disabled: true }));

            let newValue;
            const values = {};
            dialogState.allowList.forEach((field) => {
                newValue = Object.getOwnPropertyDescriptor(formData, field);

                if (!newValue || newValue.value === undefined) return;
                values[field] = formData[field];
            });
            let selectedRecords = selectedNodesData;
            if(selectedNodesKeys) {
                selectedRecords = Object.keys(selectedNodesKeys).map(selectedNodeKey => {
                    const selectedNode = findNodeAndChildren(primeValues, selectedNodeKey);
                    return selectedNode;
                });
            }

            if (values.superficie_dividida && selectedRecords.length > 1) {
                if (values.superficie) values.superficie = values.superficie / selectedRecords.length;
            }

            const changedRecords = selectedRecords.map((record) => {
                const changed = { ...values };
                changed[key] = record[key];
                if (record.tipo) changed.tipo = record.tipo;
                return changed;
            });
            const response = (await primeUpdateBulk(changedRecords, key, awsOptions, setLoadingDialog));
            const newValues = response.changed??response;
            if(type===TREE_TABLE){
                for (let i = 0; i < newValues.length; i++) {
                    let node = primeValues;
                    const newNode = newValues[i];
                    const nodeKey = findKey(primeValues, key, newNode);
                    const indexes = nodeKey.split("-").map(Number);
                    for (let j = 0; j < indexes.length; j++) {
                        const index = indexes[j];
                        if (node[index] && node[index].children) {
                            node = node[index].children;
                        } else if (j === indexes.length - 1) {
                            node[index] = {...node[index], ...newNode};
                            node[index].data = {...node[index], ...newNode};
                        } else {
                            return false;
                        }
                    }
                }
            }
            if(type === DATA_TABLE){
                const nodes = primeValues;
                for (let i = 0; i < newValues.length; i++) {
                    const newNode = newValues[i];
                    const index = nodes.findIndex(n => n[key] === newNode[key]);
                    if(index >=0){
                        nodes[index] = {...nodes[index], ...newNode};
                    }
                }
            }
            setPrimeValues(primeValues);
            setLoadingDialog(false);
        }
    } catch (e) {
        if (disabled) setDialogState((e) => ({ ...e, disabled: false }));
        throw e;
    }
};
const primeUpdateBulk = async (changedRecords, key, awsOptions, setLoadingDialog) => {
    const { areaInfo, hidraInfo, sectorsInfo, canModify,url,  promiseWrapper, extraData, t, closeEstadosRef } = awsOptions?.current || {};
    let value;
    let cache, cacheKey; // since we prob have the same area values for all modifications, transform it just once
    const modified = changedRecords.map((c) => {
        const record = { id: c[key], values: {} };
        canModify && canModify.forEach((field) => {
            value = c[field];
            if (value === undefined) return;
            record.values[field] = value === "" ? null : value;
        });
        if (c.tipo) record.values.tipo = c.tipo;
        return record;
    }).filter(({ id }) => Boolean(id));

    if (canModify.includes("grupo_variador_id") && hidraInfo && sectorsInfo) {
        modified.forEach(m => {
            m.values.variador_frecuencia_id = hidraInfo.variador_frecuencia_id;
            m.values.hidraulica_id = hidraInfo.hidraulica_id;
            for (const s of sectorsInfo) {
                if (m.id === s.sector_id) {
                    m.values.grupo_variador_id = s.grupo_variador_id;
                    break;
                }
            }
        });
    }
    if (!modified.length) return { key };
    try {
        const { formula_from_base, formula_to_base, formula_to_kilo_base, formula_from_kilo_base } = areaInfo || {};
        // convert from unidad to kilo_unidad
        cache = {};
        for (let i = 0; i < modified.length; i++) {
            const { values } = modified[i];
            cacheKey = values && values.superficie;
            if (cacheKey && formula_from_base && formula_to_base) {
                if (cache[cacheKey]) {
                    values.superficie = cache[cacheKey];
                } else {
                    // we can use formula2( formula1( sup * 10.000 ) )
                    // instead of formula2( formula1( sup ) * 10.000 ) for area
                    cache[cacheKey] = values.superficie = applyFormulas(cacheKey * 10000, formula_to_kilo_base, formula_from_base);
                }
            }

            if ((values.superficie !== undefined) || (values.caudal_teorico !== undefined)) {
                if (cache.recalc !== undefined) {
                    values.recalc = cache.recalc;
                } else if (promiseWrapper && promiseWrapper.current) {
                    setLoadingDialog(false);
                    cache.recalc = values.recalc = await promiseWrapper.current.getPromiseAnswer();
                    setLoadingDialog(true);
                }
            }
            if (extraData) Object.assign(values, extraData);
        }

        const someSectorWithPlantilla = sectorsInfo?.some(s => s.plantilla_estado_fenologico_id);
        const bulkPlantillaModified = modified.some(m => m.values.plantilla_estado_fenologico_id !== undefined);
        if (someSectorWithPlantilla && bulkPlantillaModified){
            setLoadingDialog(false);
            const closeEstados = await closeEstadosRef.current.getPromiseAnswer();
            setLoadingDialog(true);
            if (!closeEstados) return { key, changed: sectorsInfo };
        }

        const data = await RestAPI.post("apiAdminDropControl", `${url}/bulk`, { body: modified });
        if (!data || data.length < 1) throw new Error("No values were modified");
        // convert from unidad to kilo_unidad
        cache = {};
        data.forEach((res) => {
            cacheKey = res && res.superficie;
            if (res.superficie !== undefined) res.apiArea = res.superficie;
            if (cacheKey && formula_from_base && formula_to_base) {
                if (cache[cacheKey]) {
                    res.superficie = cache[cacheKey];
                } else {
                    // we can use formula2( formula1( sup / 10.000 ) )
                    // instead of formula2( formula1( sup ) / 10.000 ) for area
                    cache[cacheKey] = res.superficie = applyFormulas(cacheKey / 10000, formula_to_base, formula_from_kilo_base, AREA_FORMAT_KEY);
                }
            }
        });

        if (data.length !== modified.length) {
            toast.success(t("forms.toastInfoNotAll"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
        } else {
            toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
        }

        const ticketFound = data.find(row => row.ticketResult);
        if (ticketFound){
            let ticketMessage;
            if (ticketFound.ticketResult.ticketCreated || ticketFound.ticketResult.emailSent) ticketMessage = t("forms.ticketCreated");
            if (ticketFound.ticketResult.ticketUpdated) ticketMessage = t("forms.ticketUpdated");
            if (ticketFound.ticketResult.ticketId) ticketMessage += ` ${t("forms.ticketId", { id: ticketFound.ticketResult.ticketId })}`;
            if (ticketMessage) toast.info(ticketMessage, { position: toast.POSITION.TOP_RIGHT, autoClose: false });
        }

        return { key, changed: data };
    } catch (err) {
        toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
        throw err;
    }
};
export { addDataAWS, deleteDataAWS, modifyDataAWS, primeUpdate, TREE_TABLE,DATA_TABLE, findNodeAndChildren, isInDateRange, createDateTimeFromString, getTimeFromDate, escapeXML, hourSet};
